import Typography from '@mui/material/Typography';
import OcchrlyGraph from './OcchrlyGraph';
import { variableName } from '../js/constants';
import { getAcisData, windchill, heatindex } from '../js/dataAccessRoutines';
import { roundValue } from '../js/utilityRoutines';

// Hourly occurrences processing //

const sendResults = (results, title, subtitle, setResult) => {
  if (results) {
      const code = (
        <OcchrlyGraph 
            options={{...results.highChartOptions, title: { text: title}, subtitle: { text: subtitle}}}
        />
      );
      setResult(code)
  } else {
    setResult("")
  }
}

const summarize = (res, userParams) => {
   //set up series for HighCharts
    const seriesData = []
    Object.keys(res).map((key,d) => {
        const dlyvals = res[key];
        const [mm, dd] = key.split("-")
        const sum = dlyvals.reduce((accum, current) => accum + current, 0);
        dlyvals.forEach((v, i) => {
            const pct = sum > 0 ? (v / sum) * 100 : 0;
            const dt =  Date.UTC(2023, mm-1, dd);
            seriesData.push([dt, i+1, roundValue(pct,1)])
        })
    })
    
    console.log(seriesData)

    // save HighCharts options
    const v = variableName[userParams.variable]
    const highChartOptions = {
        series: [{
            data: seriesData,
            name:  v.name + " (" + v.units + ")",
            boostThreshold: 100,
            borderWidth:0,
            colsize: 24 * 36e5, // one day
            nullColor: '#EFEFEF',
            tooltip: {
                headerFormat: 'Temperature<br/>',
                pointFormat: '{point.x:%e %b} {point.y}:00: <b>{point.value}%</b>'
            },
            dataLabels: {
                enabled: true, // Enable data labels
                format: '{point.value}', // Format to show the y-value
            }
        }]
    }

    return highChartOptions;
}

const processData = (res, userParams) => {
  var vals, dlyvals, dlymiss, dlysmry;
  const allowMissing = 3;
  const missVal = userParams.smry === 'hrofmax' ? -999 : 999;
  const interResults = {}
  const noVal = 'na'  //code for when wind chill or heat index input outside range
  //process
  res.data.forEach((results) => {
    let mmdd = results[0].slice(5)
    if (mmdd === '02-29') return;   //skip leap days
    if (!interResults.hasOwnProperty(mmdd)) {
        interResults[mmdd] = Array(24).fill(0);
    }
    // derived variables
    if (userParams.variable === 'wchill') {
      vals = windchill(results[1], results[2], noVal)
    } else if (userParams.variable === 'htindx') {
      vals = heatindex(results[1], results[2], noVal)
    } else {
      vals = results[1]
    }

    // create an array of hourly values (strings to float)
    dlyvals = [];
    dlymiss = 0;
    vals.forEach((v) => {
        const rval = ["M", noVal].includes(v) ? missVal : parseFloat(v);
        if (rval === missVal) {
            dlymiss += 1;
        }
        dlyvals.push(rval === missVal ? null : rval)
    })
    if (dlymiss <= allowMissing) {
        dlysmry = userParams.smry === 'hrofmax' ? Math.max(...dlyvals) : Math.min(...dlyvals);
        // Find all indices of this value
        const dlyIndices = [];
        dlyvals.forEach((v, index) => {
            if (v === dlysmry) {
                interResults[mmdd][index] += 1
            }
        });
    }
  })
  const highChartOptions = summarize(interResults, userParams)
  return {highChartOptions}
}

export function processOcchrly(userParams, setResult, hourlyVx) {
    const sid = userParams.sid;
    const network = sid.indexOf(" ") > 0 ? sid.split(" ")[1] : 'icao';
    // some variables need to be calculated from others; get what's needed
    var elems;
    if (userParams.variable === 'wchill') {
      elems = [ {vX: hourlyVx[network]['temp']}, {vX: hourlyVx[network]['wspd']} ]
    } else if (userParams.variable === 'htindx') {
      elems = [ {vX: hourlyVx[network]['temp']}, {vX: hourlyVx[network]['rhum']} ]
    } else {
      elems = [ {vX: hourlyVx[network][userParams.variable]} ]
    }
    const acisParams = {
        sid: sid,
        sDate: userParams.fromFilterYear + "-01-01",
        eDate: userParams.toFilterYear + "-12-31",
        elems: elems
    }
    getAcisData(acisParams)
    .then(res => {
      const results = processData(res, userParams);
      const title = variableName[userParams.variable].name + " " + userParams.smry;
      const subtitle = res.meta.name + ", " + res.meta.state;
      sendResults(results, title, subtitle, setResult)
    })
    .catch(error =>  { 
      console.log("Data retrieval error: " + error);  
      setResult((
        <Typography sx={{color: "red"}}>
          Error processing request - error
        </Typography>
      ))
    })
}